<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="dedication"><a id="page_xix"></a><em>There’s but the twinkling of a star<br/>Between a man of peace and war.</em><br/><br/>—S<span class="smallcaps">AMUEL</span> B<span class="smallcaps">UTLER</span>,<br/><em>Hudibras II.</em> Part iii. 957.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?eca65d6a